import React, { useState } from "react";
import {motion} from "framer-motion";

function Ressources() {
    const filters = [
        "Contacts",
        "Dispositifs et aides",
        "Ressources utiles",
        "Documents utiles",
        "Accord handicap La Halle",
    ];

    const [page, setPage] = useState(0);

    const handleClick = (event, pageId) => {
        event.preventDefault();
        if (page !== pageId) setPage(pageId);
    };

    const tabContents = [
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ ease: 'easeInOut', duration: 0.5 }}
            key="tab0"
            className={'tab-content-item nunito'}>


            <div className={'tab-content-item-title'}>
                <img className={'tab-content-item-icon'} src="../images/resssources_handicap/relais.svg" alt="" />
                <span>Vos relais internes</span>
            </div>
            <ul>
                <li>
                    Vos référents RH pourront répondre à vos questions liées à
                    l’impact de votre handicap dans votre quotidien au sein de La Halle.
                </li>
                <li>
                    <div>
                        Pour toute question ou besoin d’accompagnement, les salariés du réseau peuvent écrire
                        à <a href="mailto:rh.pegase@lahalle.fr">rh.pegase@lahalle.fr</a>,
                        et les salariés du siège sont invités à se rapprocher de leur <b>Responsable RH</b>.
                    </div>
                </li>
            </ul>

            <div className={'tab-content-item-title'}>
                <img className={'tab-content-item-icon'} src="../images/resssources_handicap/sante.svg" alt="" />
                <span>Vos experts santé</span>
            </div>
            <ul>
                <li>
                    Le médecin du travail est présent pour vous renseigner sur vos questions de santé et vos démarches.
                    Il peut également vous orienter vers des médecins externes ou des professionnels de santé,
                    et réaliser si besoin une étude de votre poste en fonction de votre pathologie.
                </li>
            </ul>



            <div className={'tab-content-item-title'}>
                <img className={'tab-content-item-icon'} src="../images/resssources_handicap/experts.svg" alt="" />
                <span>Vos relais externes</span>
            </div>
            <ul>
                <li>
                    La Maison Départementale des Personnes Handicapées (MDPH) pourra répondre à toutes vos questions.
                </li>
            </ul>
        </motion.div>,

        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ ease: 'easeInOut', duration: 0.5 }}
            key="tab1"
            className={'tab-content-item tab-content-item-aides nunito'}>

            <div className={'tab-content-item-title'}>
                <span>BOETH et RQTH :</span>
            </div>
            <div className={'tab-content-item'}>
                Talents Handicap a rédigé un article « Qui sont les personnes BOETH ou RQTH et quels sont leurs droits ? »
                pour comprendre comment être Bénéficiaire de l’Obligation d’Emploi de Travailleurs Handicapés (BOETH),
                comme lorsqu’on a la RQTH (Reconnaissance de la Qualité de Travailleur Handicapé).
                Lire l’article sur :

                <a href="https://www.talents-handicap.com/ressources/boeth-rqth" target="_blank" rel="noopener noreferrer">
                    https://www.talents-handicap.com/ressources/boeth-rqth
                </a>
            </div>

            <div className={'tab-content-item-title'}>
                <span>Vos démarches en ligne auprès de votre MDPH :</span>
            </div>
            <div className={'tab-content-item'}>
                La plupart des départements permettent aujourd’hui de faire des démarches en ligne auprès
                de la MDPH (Maison Départementale pour les Personnes handicapées),
                comme pour faire une demande de la RQTH.
                <br/>
                Ces services en ligne sont accessibles sur le lien suivant :


                <a href="https://mdphenligne.cnsa.fr/" target="_blank" rel="noopener noreferrer">
                    https://mdphenligne.cnsa.fr/
                </a>
            </div>


            <div className={'tab-content-item-title'}>
                <span>Les solutions d’aménagement de poste et des conditions de travail :</span>
            </div>
            <div className={'tab-content-item'}>
                Retrouvez un article sur le sujet rédigé par Talents Handicap :


                <a href="https://www.talents-handicap.com/ressources/les-amenagements-de-poste" target="_blank" rel="noopener noreferrer">
                    https://www.talents-handicap.com/ressources/les-amenagements-de-poste
                </a>
            </div>

            <div className={'tab-content-item-title'}>
                <span>Les solutions de compensation proposées par l’Agefiph :</span>
            </div>
            <div className={'tab-content-item'}>
                Consultez la page ressources suivante :
                <a href="https://www.agefiph.fr/articles/conseil-pratiques/quelles-solutions-de-compensation-proposees-par-lagefiph" target="_blank" rel="noopener noreferrer">
                    https://www.agefiph.fr/articles/conseil-pratiques/quelles-solutions-de-compensation-proposees-par-lagefiph
                </a>
            </div>

            <div className={'tab-content-item-title'}>
                <span>Les aides financières de l’Agefiph : </span>
            </div>
            <div className={'tab-content-item'}>
                <a href="https://www.agefiph.fr/aides-financieres" target="_blank" rel="noopener noreferrer">
                    https://www.agefiph.fr/aides-financieres
                </a>
            </div>

            <div className={'tab-content-item-title'}>
                <span>Les aides France Travail :</span>
            </div>
            <div className={'tab-content-item'}>
                <a href={'/docs/lahalle/Aides_l_embauche_France_Travail_Pro_Juillet_2025_1753724639.pdf'}
                   target='_blank'
                   rel="noopener noreferrer"
                >
                    Télécharger le guide embauche France Travail
                </a>
            </div>



        </motion.div>,

        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ ease: 'easeInOut', duration: 0.5 }}
            key="tab2"
            className={'tab-content-item tab-content-item-aides nunito'}>
                <div className={'tab-content-item-title'}>
                    <span>Comprendre la loi du 11 février 2005 pour l’égalité des droits et des chances,
                        la participation et la citoyenneté des personnes handicapées
                    </span>
                </div>
                <div className={'tab-content-item'}>
                    <a href="https://www.talents-handicap.com/ressources/loi-handicap-du-11-fevrier-2005" target="_blank" rel="noopener noreferrer">
                        https://www.talents-handicap.com/ressources/loi-handicap-du-11-fevrier-2005
                    </a>
                </div>

                <div className={'tab-content-item-title'}>
                    <span>Les sites utiles des principaux acteurs : </span>
                </div>



                <ul>
                    <li>
                        Agefiph :{" "}
                        <a href="https://www.agefiph.fr/" target="_blank" rel="noopener noreferrer">
                            https://www.agefiph.fr/
                        </a>
                    </li>
                    <li>
                        Mon Parcours Handicap (site du gouvernement) :{" "}
                        <a
                            href="https://www.monparcourshandicap.gouv.fr/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://www.monparcourshandicap.gouv.fr/
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.capemploi.info/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://www.capemploi.info/
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://mdphenligne.cnsa.fr/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://mdphenligne.cnsa.fr/
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://www.1jeune1solution.gouv.fr/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://www.1jeune1solution.gouv.fr/
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://groupe.talents-handicap.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://groupe.talents-handicap.com/
                        </a>
                    </li>
                </ul>
                <div className={'tab-content-item-title'}>
                    <span>Le centre de ressources de l’Agefiph  </span>
                </div>
                <ul>
                    <li>
                        <a
                            href="https://www.agefiph.fr/centre-de-ressources/accueil"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            https://www.agefiph.fr/centre-de-ressources/accueil
                        </a>
                    </li>
                </ul>
        </motion.div>,
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ ease: 'easeInOut', duration: 0.5 }}
            key="tab3"
            className={'tab-content-item nunito'}>
            <div className={'tab-content-item-title'}>

            </div>

            <div className={'row'}>
                {/*<div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'#'} target='_blank' rel="noopener noreferrer"
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-pdf"></span>
                        <span className={'text-blue text-center'}>Fiche pratique « Aménager un poste de travail en cas de handicap</span>
                    </a>
                </div>*/}
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'/docs/lahalle/Observatoire_emploi_handicap_2005_2025_20_ans_d_action_regards_et_perspectives.pdf'} target='_blank' rel="noopener noreferrer"
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-pdf"></span>
                        <span className={'text-blue text-center'}>Observatoire de l’emploi et du handicap 2005-2025</span>
                    </a>
                </div>
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'/docs/lahalle/Parcours_MDPH_1755500842.pdf'} target='_blank' rel="noopener noreferrer"
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-pdf"></span>
                        <span className={'text-blue text-center'}>Le parcours MDPH</span>
                    </a>
                </div>
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'/docs/lahalle/Guide_Agefiph_des_acteurs.pdf'} target='_blank' rel="noopener noreferrer"
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons doc-icons fa fa-file-pdf"></span>
                        <span className={'text-blue text-center'}>Guide Agefiph des acteurs du handicap</span>
                    </a>
                </div>

                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'/docs/lahalle/Strategie_Innovation_recherche_de_l_Agefiph_2024_2027_1750532260.pdf'} target='_blank' rel="noopener noreferrer"
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-pdf"></span>
                        <span className={'text-blue text-center'}>Stratégie Innovation Recherche de l’Agefiph 2024-2027</span>
                    </a>
                </div>
            </div>

            <div className={'row'}>
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'/docs/lahalle/Guide_Apprentissage_et_Handicap_1750308939.pdf'} target='_blank' rel="noopener noreferrer"
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-pdf"></span>
                        <span className={'text-blue text-center'}>Guide Apprentissage et handicap</span>
                    </a>
                </div>
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'/docs/lahalle/Guide-des-bonnes-pratiques-Accessibilite-numerique-Manifeste-Inclusion.pdf'} target='_blank' rel="noopener noreferrer"
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-pdf"></span>
                        <span className={'text-blue text-center'}>Guide des bonnes pratiques de l’accessibilité numérique</span>
                    </a>
                </div>
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'/docs/lahalle/Aides_l_embauche_France_Travail_Pro_Juillet_2025_1753724639.pdf'} target='_blank' rel="noopener noreferrer"
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons doc-icons fa fa-file-pdf"></span>
                        <span className={'text-blue text-center'}>Aide embauche France Travail</span>
                    </a>
                </div>
            </div>

        </motion.div>,

        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ ease: 'easeInOut', duration: 0.5 }}
            key="tab4"
            className={'nunito'}>
            <div className={'tab-content-item-title'}>
                <span>Engagement 2025-2027</span>
            </div>
            <div className={'tab-content-item small'}>
                La Halle s'engage dans une démarche inclusive ambitieuse avec cet accord handicap triennal.
                Cette feuille de route structurée vise à transformer notre approche du handicap en entreprise,
                de l'embauche au maintien dans l'emploi, en passant par la sensibilisation de tous nos collaborateurs.
                Voici les principaux axes de notre accord 2025-2027 :
            </div>
            <div className={'row accord-lahalle mb-3 mt-3'}>
                <div className={'col-sm-6 col-lg-4 col-xs-4'}>
                    <div className="blox">
                        <strong>Recrutement Inclusif</strong>
                        <ul>
                            <li><b>14 embauches</b> programmées sur 3 ans grâce à nos partenariats renforcés avec France Travail, Cap Emploi et notre présence active dans les forums spécialisés.
                            </li>
                            <li>Formation dédiée de nos recruteurs et managers pour garantir un processus d'embauche équitable et adapté.
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={'col-sm-6 col-lg-4 col-xs-4'}>
                    <div className="blox">
                    <strong>Insertion Réussie</strong>
                    <ul>
                        <li>
                            Déploiement d'un <b>livret d'accueil spécialisé</b> et sensibilisation systématique des équipes d'accueil.
                        </li>
                        <li>
                            Financement intégral des adaptations de postes et aménagements nécessaires pour chaque situation.
                        </li>
                    </ul>
                    </div>
                </div>
                <div className={'col-sm-6 col-lg-4 col-xs-4'}>
                    <div className="blox">
                    <strong>Formation Accessible</strong>
                    <ul>
                        <li>
                            Modules e-learning <b>100% accessibles</b> et formations compensatoires personnalisées selon les besoins.
                        </li>
                        <li>
                            Priorité absolue donnée aux recommandations médicales dans l'élaboration des parcours de formation.
                        </li>
                    </ul>
                    </div>
                </div>
            </div>
            <hr className={'mb-2 mt-2'}/>
            <div className={'row accord-lahalle mb-2 mt-3'}>
                <div className={'col-sm-6 col-lg-4 col-xs-4'}>
                    <div className="blox">
                    <div className={'mb-4'}><strong>Maintien dans l'Emploi</strong></div>
                    L'accompagnement des collaborateurs en situation de handicap est une priorité. Notre dispositif
                    RQTH prévoit <b>2 jours d'absence autorisés</b> pour rendez-vous médicaux. Sont inclus :
                    aménagements horaires flexibles, télétravail facilité, reclassements accompagnés
                    et suivi personnalisé par nos référents handicap.
                    </div>
                </div>
                <div className={'col-sm-6 col-lg-4 col-xs-4'}>
                    <div className="blox">
                        <div className={'mb-4'}><strong>Sensibilisation Continue</strong></div>
                    <b>4 campagnes annuelles</b> de sensibilisation déployées dans tous nos établissements.
                    Webinaires réguliers et participation active à la Semaine Européenne
                    pour l'Emploi des Personnes Handicapées (SEEPH).
                    </div>
                </div>
                <div className={'col-sm-6 col-lg-4 col-xs-4'}>
                    <div className="blox">
                        <div className={'mb-4'}><strong>Partenariats Stratégiques</strong></div>
                    <b>2 nouveaux partenariats par an</b> avec ESAT, Entreprises Adaptées et Travailleurs Indépendants Handicapés.
                    Prestations confiées : restauration d'entreprise, services de nettoyage, travaux d'impression.
                    </div>
                </div>
            </div>

            <div className={'row accord-lahalle mb-4'}>
                <div className={'col-sm-12 col-lg-12 col-xs-12'}>
                    <div className="blox blox-last">
                        <div className={'mb-4'}><strong>Pilotage & Suivi</strong></div>
                    <b>4 référents handicap</b> dédiés : 3 en magasins + 1 au siège social. Suivi CSSCT,
                    bilans annuels au CSE, indicateurs emploi, formations et adaptations pour un suivi rigoureux.
                    </div>
                </div>
            </div>
            <div className={'tab-content-item small'}>
                Cet accord handicap marque une étape décisive dans notre engagement sociétal. Il traduit notre volonté de faire de La Halle un employeur exemplaire, où chaque talent trouve sa place, quelles que soient ses spécificités. La réussite de cette démarche repose sur l'implication de tous : direction, managers, référents handicap, services RH et représentants du personnel unis dans cette ambition commune.
            </div>
        </motion.div>
    ];

    return (
        <section className="ressources-section layout-pt-60 layout-pb-40" id="resources" style={{ minHeight : "400px" }}>
            <div className="auto-container">
                <div className="text-center">
                    <h2 className="libre-title raleway">
                        Vos ressources handicap <span>à portée de clic</span>
                    </h2>
                </div>

                <div className="row mt-30">
                    <div className="tab-header">
                        <ul className="tab-header-menu">
                            {filters.map((filter, index) => (
                                <li
                                    key={`menu_${index}`}
                                    className={`raleway tab-header-menu-item ${
                                        index === page ? "tab-header-menu-item-active" : ""
                                    }`}
                                    onClick={(event) => handleClick(event, index)}
                                >
                                    <span>{filter}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="tab-content">{tabContents[page]}</div>

                </div>
            </div>
        </section>
    );
}

export default Ressources;
